import { Select } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FilterColumn, TRule } from '../filters.types';

type Inputs = { col: FilterColumn; value?: TRule['value'] } & {
  onChange: (value: TRule['value']) => void;
};

export const FDropdown: FC<Inputs> = ({ col, onChange, value }) => {
  const { t } = useTranslation();
  return (
    <>
      {col.type === 'dropdown' && (
        <Select
          className="w-full"
          maxTagCount={2}
          options={col.options}
          showSearch={col.allowSearch}
          allowClear={col.allowClear}
          mode={col.multipleSelect ? 'multiple' : undefined}
          value={value as number[] | number | undefined}
          onChange={onChange}
          placeholder={t('filters-select-value-placeholder')}
        />
      )}
    </>
  );
};
